module.exports = __webpack_public_path__ + "img/angle-right-solid.de814821.svg";